import type { ExperimentalMutations } from '../__types__/ExperimentalMutations';
import { MediaType } from '../MediaType';
import { throwErrorWithResponse } from '../throwErrorWithResponse';

export const experimentalArchiveSpace: ExperimentalMutations['experimentalArchiveSpace'] = (
	_,
	{ spaceKey, spaceName, description, homePageTitle, archived },
	{ network: { cfetch } },
) => {
	const formData = new FormData();
	formData.append('name', spaceName);
	// TODO FIXME `description` can be `undefined`
	// @ts-ignore
	formData.append('description', description);
	// TODO FIXME `archived` can be `undefined`
	// @ts-ignore
	formData.append('archived', archived);
	formData.append('homePageTitle', homePageTitle);
	formData.append('confirm', 'Save');

	return cfetch(`/wiki/spaces/doeditspace.action?key=${spaceKey}`, {
		method: 'POST',
		// TODO FIXME this isn't exactly correct type-wise. The easiest fix for all these issues would be to just
		// get rid of `FormData`, and replace it with an object, i.e. `new URLSearchParams({ name: spaceName, ... })`
		// @ts-ignore
		body: new URLSearchParams(formData).toString(),
		headers: {
			'Content-Type': MediaType.X_WWW_FORM_URLENCODED,
			'X-Atlassian-Token': 'no-check',
		},
	}).then(
		() => ({
			archived,
			success: true,
		}),
		(error) =>
			throwErrorWithResponse(
				new Error(`${archived ? 'ARCHIVE_FAILED' : 'RESTORE_FAILED'}`),
				error?.response,
			),
	);
};
